import { HostConfig } from './host-config.model';

export class ApiUrls {
  static residentialServiceList = () => ApiUrls.addUrlPrefix('/api/ServiceOptions');
  static residentialServiceDetails = () => ApiUrls.addUrlPrefix(`/api/ServiceDetails`);
  static residentialServiceOrder = () => ApiUrls.addUrlPrefix(`/api/ServiceOrders/create-order`);

  static rollOffServiceDetails = () => ApiUrls.addUrlPrefix(`/api/RollOffService/dumpster-service-details`);
  static rollOffServiceOrder = () => ApiUrls.addUrlPrefix(`/api/RollOffService/dumpster-create-order`);

  static commercialServiceList = () => ApiUrls.addUrlPrefix('/api/CommercialServices/service-options');
  static commercialServiceDetails = () => ApiUrls.addUrlPrefix(`/api/CommercialServices/service-details`);
  static commercialServiceOrder = () => ApiUrls.addUrlPrefix(`/api/CommercialServices/create-order`);

  static towns = () => ApiUrls.addUrlPrefix('/api/Towns');

  private static addUrlPrefix(
    url: string,
    prefix: string = (window as unknown as { hostConfig: HostConfig }).hostConfig.API,
  ): string {
    if (!url) {
      console.warn('got empty url', url);
      return '';
    }

    if (!url.startsWith('/')) {
      console.warn('url must start from "/', url);
      return '';
    }

    return prefix + url;
  }
}
